export interface ApiErrorBody {
  message?: string
  error?: Record<string, string[] | undefined>
}

/**
 * Extract a readable message from an API error response.
 * Handles `{ message }` and validation `{ success: false, error: { <field>: [msgs] } }`.
 */
export function getErrorMessage(body: unknown, fallback = "Something went wrong"): string {
  if (!body || typeof body !== "object") return fallback
  const candidate = body as Partial<ApiErrorBody>

  if (typeof candidate.message === "string" && candidate.message) {
    return candidate.message
  }

  if (candidate.error && typeof candidate.error === "object") {
    const first = Object.values(candidate.error).find((messages) => messages && messages.length > 0)
    if (first?.length) return first[0]!
  }

  return fallback
}

/**
 * Field → messages map for validation errors, for inline form display.
 */
export function fieldErrors(body: unknown): Record<string, string[] | undefined> {
  if (body && typeof body === "object" && "error" in body && body.error && typeof body.error === "object") {
    return (body as { error: Record<string, string[] | undefined> }).error
  }
  return {}
}
